import * as React from 'react';
import './Profile.scss';
import profileTopLogo from '../../assets/images/Profile/profile_top_logo.png';
import greenTik from '../../assets/images/greenTik.png';


import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { postData } from '../../Shared/FackeDataFactory';
import ScrollContainer from 'react-indiana-drag-scroll';
import useClickOutside from '../../Hooks/useClickOutside';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { allFollowersPeoplesData } from '../../Shared/GlobalDataFactory';
export interface IAppProps {
}

export function Profile(props: IAppProps) {


    const [verifiedArtist, setVerifiedArtist] = React.useState(false)
    const verifiedArtistRef = React.useRef(null)
    useClickOutside(verifiedArtistRef, () => setVerifiedArtist(false))


    // const [shareSmallModalOpen, setShareSmallModalOpen] = React.useState(false);
    // const shareSmallModalRef = React.useRef<HTMLHeadingElement>(null);
    // useClickOutside(shareSmallModalRef, () => setShareSmallModalOpen(false))


    // Share modal-------
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const shareModalRef = React.useRef(null);
    useClickOutside(shareModalRef, () => setShareModalOpen(false))

    const [modalPeoplesData, setModalPeoplesData] = useState(allFollowersPeoplesData)

    const handleShareModalSearch = (e: any) => {
        const prevModalPeopleData = [...allFollowersPeoplesData]
        const findMatchPeoples = prevModalPeopleData.filter(data => data.name.toLowerCase().includes(e.target.value.toLowerCase()))

        setModalPeoplesData(findMatchPeoples);
    }





    const smallNavItemStyles = 'font-bold dark:font-normal xs:text-xs xsm:text-xs whitespace-nowrap sm:text-base xs:px-2 sm:px-4 small_nav_item pb-4';
    return (
        <div className="profile_main_box pt-[64px] sm:pt-[80px] ">

            <div className="xs:py-9 sm:py-0 h-32 sm:h-40 md:h-44 lg:h-48 xl:h-64 w-full top_section bg-cover bg-center flex justify-center items-center bg-no-repeat relative">
                <div className="hidden dark:block bg-[#140d3696] absolute top-0 left-0 w-full h-full"></div>
            </div>



            <div className="bg-white dark:bg-cusDeepPurper w-full h-14 sm:h-20 md:h-24 lg:h-28 2xl:h-20">
                <div className="
                sm:max-w-[570px] md:max-w-[660px] lg:max-w-[800px] xl:max-w-[1100px] 2xl:max-w-[1336px] 3xl:max-w-[1436px]
                mx-auto xs:px-2 xsm:px-4 flex justify-between items-center w-full h-full relative">

                    <div className="flex justify-start items-center">
                        <div className="
                        w-[60px] h-[60px]
                        xxsm:w-[90px] xxsm:h-[90px]
                        sm:w-[110px] sm:h-[110px]
                        xl:w-[150px] xl:h-[150px]
                        2xl:w-[170px] 2xl:h-[170px] p-[2px] md:p-[3px]
                        rounded-full profile_logo_bg relative -mt-[35px] md:mt-[-15px] lg:mt-[0px] xl:-mt-[80px] 2xl:-mt-[92px]">
                            <div className="w-full h-full bg-white dark:bg-cusBlack rounded-full p-0.5 xxsm:p-1 sm:p-1.5">
                                <img src={profileTopLogo} alt="" className="w-full h-full" />
                            </div>
                        </div>

                        <div className="flex-1 ml-1 xxsm:ml-2.5 xl:ml-3 2xl:ml-4 text-left">
                            <div className="flex justify-start items-start">
                                <h4 className="inline-block text-sm xsm:text-base sm:text-lg truncate md:text-xl text-cusBlack dark:font-medium font-semibold dark:text-white text-semibold">Donald Trump</h4>

                                <motion.button
                                    whileTap={{ scale: 0.9 }}
                                    onClick={() => setVerifiedArtist(!verifiedArtist)}
                                    className="px-2 2xl:px-3 py-0.5 xsm:py-1 2xl:py-1.5 rounded-full flex
                                bg-[#FF010117] dark:bg-[#ff010129] border-[#FF0101] border-2 ml-2 2xl:ml-3
                                justify-center items-center">
                                    <p className="text-[#FF0101] text-xxs xl:tracking-tighter 2xl:tracking-normal 2xl:text-xs
                                     font-semibold truncate w-[70px] xxsm:w-24 xsm:w-auto md:w-10 lg:w-auto">Request for verification</p>
                                </motion.button>

                                {/* ---------------------------If the profile will be verified then this icon will be shown--------------------------- */}
                                {/* <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="xs:ml-1 2xl:ml-2 -mb-2 xs:w-7 sm:w-8 md:w-auto" width="35.74" height="35.673" viewBox="0 0 35.74 35.673">
                                    <defs> 
                                        <filter id="Path_682" x={0} y={0} width="35.74" height="35.673" filterUnits="userSpaceOnUse">
                                            <feGaussianBlur stdDeviation={3} result="blur" />
                                            <feFlood floodColor="#f08" floodOpacity="0.314" />
                                            <feComposite operator="in" in2="blur" />
                                            <feComposite in="SourceGraphic" />
                                        </filter>
                                    </defs>
                                    <g id="Group_1214" data-name="Group 1214" transform="translate(-546.155 -743.31)">
                                        <g transform="matrix(1, 0, 0, 1, 546.15, 743.31)" filter="url(#Path_682)">
                                            <path id="Path_682-2" data-name="Path 682" d="M631.76,279.583s7.714-1.937,14.928,0a34.6,34.6,0,0,1-.067,14.794,34.923,34.923,0,0,1-14.894.033S629.856,286.462,631.76,279.583Z" transform="translate(-621.3 -272.11)" fill="#ff0091" stroke="#c90072" strokeMiterlimit={10} strokeWidth={1} />
                                        </g>
                                        <image id="Image_44" data-name="Image 44" width={11} height={11} transform="translate(558.465 752.613)" xlinkHref="data:image/png;base64,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" />
                                    </g>
                                </svg> */}
                            </div>
                            <p className="xs:text-xxs sm:text-xs md:text-base text-cusBlack dark:text-white truncate">Joined April 2022</p>


                        </div>
                    </div>



                    <div className="flex flex-col xl:flex-row justify-center items-end xl:items-center">
                        <div className="hidden md:flex xs:justify-start xl:justify-end items-center space-x-2 xl:space-x-3 edit_share_dot_btn_Box">

                            <div className="px-2 py-1.5 lg:py-2 xl:p-3 2xl:px-4 2xl:py-3.5 3xl:p-4 flex justify-between
                             items-center rounded-md xl:rounded-xl bg-[#E9E9E9] dark:bg-[#8782ffc2]">
                                <svg className="w-[10px] lg:w-[13px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                    <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                    <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                    <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                    <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                    <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                    <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                </svg>

                                <p className="text-xxs lg:text-xs text-cusBlack dark:text-white ml-3">0x60e4d7.....6a7c6</p>
                            </div>

                            <motion.div
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                <NavLink to="/settings/profile" className="flex justify-center items-center
                               relative filter drop-shadow-md global_icons_only_hover
                                md:w-[30px] md:h-[30px]
                                lg:w-[40px] lg:h-[40px]
                                xl:w-[45px] xl:h-[45px]
                                2xl:w-[52px] 2xl:h-[52px]">
                                    <svg className="w-full h-full absolute inset-0 z-[-1] 
                                    fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                        viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-3 lg:w-4 2xl:w-6 fill-cusBlack dark:fill-white" width="22.641" height="22.641" viewBox="0 0 22.641 22.641">
                                        <g id="pencil" transform="translate(0.037)">
                                            <g id="Group_1388" data-name="Group 1388" transform="translate(10.422 20.429)">
                                                <path id="Path_929" data-name="Path 929" d="M247.577,462h-9.971a1.105,1.105,0,1,0,0,2.211h9.971a1.105,1.105,0,1,0,0-2.211Z" transform="translate(-236.5 -462)" fill="" />
                                            </g>
                                            <path id="Path_930" data-name="Path 930" d="M21.716,3.148,19.461.893a3.021,3.021,0,0,0-4.285,0L1.11,14.955a3.908,3.908,0,0,0-1.141,2.98l0,3.6A1.1,1.1,0,0,0,1.07,22.64l3.6,0a3.908,3.908,0,0,0,2.98-1.141l2.874-2.87.04-.04L21.716,7.429a3.021,3.021,0,0,0,0-4.28ZM20.155,5.863l-.783.783L15.959,3.232l.783-.783a.822.822,0,0,1,1.159,0L20.155,4.7A.822.822,0,0,1,20.155,5.863Z" transform="translate(0)" fill="" />
                                        </g>
                                    </svg>
                                </NavLink>
                            </motion.div>


                            <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                onClick={() => setShareModalOpen(!shareModalOpen)}
                                className="flex justify-center items-center
                                relative filter drop-shadow-md global_icons_only_hover
                                md:w-[30px] md:h-[30px]
                                lg:w-[40px] lg:h-[40px]
                                xl:w-[45px] xl:h-[45px]
                                2xl:w-[52px] 2xl:h-[52px]">
                                <svg className="w-full h-full absolute inset-0 z-[-1] 
                                    fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                    viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-[14px] lg:w-[18px] 2xl:w-6 fill-cusBlack dark:fill-white" width="24.476" height="24.475" viewBox="0 0 24.476 24.475">
                                    <path id="Union_10" data-name="Union 10" d="M10136.334,14296.156a4.8,4.8,0,0,1,.262-1.57l-6.182-3.3a4.822,4.822,0,1,1,.015-5.075l6.177-3.294a4.828,4.828,0,1,1,.706,1.313l-6.306,3.363a4.849,4.849,0,0,1-.007,2.314l6.3,3.358a4.82,4.82,0,1,1-.961,2.888Z" transform="translate(-10121.501 -14276.502)" fill="" />
                                </svg>
                            </motion.button>
                        </div>


                        <div className="gradientBG mt-1 xl:mt-0 hidden md:grid
                        xl:ml-2.5 3xl:ml-3.5 h-fit w-fit xs:rounded-md xl:rounded-xl grid-cols-5
                        2xl:gap-x-0
                        3xl:gap-x-2
                        px-3 py-1 xl:py-2
                        profileSummaryBox">
                            <div className="m-0 p-0 text-center">
                                <h3 className="text-white text-xs lg:text-sm 2xl:text-base 3xl:text-lg font-black">$1.4M</h3>
                                <p className="text-3xs lg:text-xxs 2xl:text-sm text-white">Highest Sale</p>
                            </div>
                            <div className="m-0 p-0 text-center">
                                <h3 className="text-white text-xs lg:text-sm 2xl:text-base 3xl:text-lg font-black">$79.1K</h3>
                                <p className="text-3xs lg:text-xxs 2xl:text-sm text-white">Floor price</p>
                            </div>
                            <div className="m-0 p-0 text-center">
                                <h3 className="text-white text-xs lg:text-sm 2xl:text-base 3xl:text-lg font-black">$1.5B</h3>
                                <p className="text-3xs lg:text-xxs 2xl:text-sm text-white">Market Cap</p>
                            </div>
                            <div className="m-0 p-0 text-center">
                                <h3 className="text-white text-xs lg:text-sm 2xl:text-base 3xl:text-lg font-black">18.6K</h3>
                                <p className="text-3xs lg:text-xxs 2xl:text-sm text-white">Items</p>
                            </div>
                            <div className="m-0 p-0 text-center">
                                <h3 className="text-white text-xs lg:text-sm 2xl:text-base 3xl:text-lg font-black">12.3K</h3>
                                <p className="text-3xs lg:text-xxs 2xl:text-sm text-white">Owners</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>









            <div className="sm:max-w-[570px] md:max-w-[660px] lg:max-w-[800px] xl:max-w-[1100px] 2xl:max-w-[1336px] 3xl:max-w-[1436px] mx-auto xs:px-3 xsm:px-5">
                <div className="flex md:hidden justify-between items-center mt-3 space-x-2">
                    <div className="gradientBtn h-fit w-fit xs:rounded-md grid grid-cols-5
                        px-1 py-1
                        profileSummaryBox">
                        <div className="m-0 p-0 text-center">
                            <h3 className="text-white text-3xs xxsm:text-xxs xsm:text-sm sm:text-sm font-black">$1.4M</h3>
                            <p className="xs:text-4xs xsm:text-xxs text-white">Highest Sale</p>
                        </div>
                        <div className="m-0 p-0 text-center">
                            <h3 className="text-white text-3xs xxsm:text-xxs xsm:text-sm sm:text-sm font-black">$79.1K</h3>
                            <p className="xs:text-4xs xsm:text-xxs text-white">Floor price</p>
                        </div>
                        <div className="m-0 p-0 text-center">
                            <h3 className="text-white text-3xs xxsm:text-xxs xsm:text-sm sm:text-sm font-black">$1.5B</h3>
                            <p className="xs:text-4xs xsm:text-xxs text-white">Market Cap</p>
                        </div>
                        <div className="m-0 p-0 text-center">
                            <h3 className="text-white text-3xs xxsm:text-xxs xsm:text-sm sm:text-sm font-black">18.6K</h3>
                            <p className="xs:text-4xs xsm:text-xxs text-white">Items</p>
                        </div>
                        <div className="m-0 p-0 text-center">
                            <h3 className="text-white text-3xs xxsm:text-xxs xsm:text-sm sm:text-sm font-black">12.3K</h3>
                            <p className="xs:text-4xs xsm:text-xxs text-white">Owners</p>
                        </div>
                    </div>
                    <div className="flex justify-end items-center space-x-2">
                        <NavLink to="/settings/profile" className="flex justify-center items-center
                        relative filter drop-shadow-md global_icons_only_hover
                        w-[35px] h-[35px]
                        xsm:w-[42px] xsm:h-[42px]">
                            <svg className="w-full h-full absolute inset-0 z-[-1] 
                                    fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                            </svg>

                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-3 sm:w-4 md:w-4 fill-cusBlack dark:fill-white" width="22.641" height="22.641" viewBox="0 0 22.641 22.641">
                                <g id="pencil" transform="translate(0.037)">
                                    <g id="Group_1388" data-name="Group 1388" transform="translate(10.422 20.429)">
                                        <path id="Path_929" data-name="Path 929" d="M247.577,462h-9.971a1.105,1.105,0,1,0,0,2.211h9.971a1.105,1.105,0,1,0,0-2.211Z" transform="translate(-236.5 -462)" fill="" />
                                    </g>
                                    <path id="Path_930" data-name="Path 930" d="M21.716,3.148,19.461.893a3.021,3.021,0,0,0-4.285,0L1.11,14.955a3.908,3.908,0,0,0-1.141,2.98l0,3.6A1.1,1.1,0,0,0,1.07,22.64l3.6,0a3.908,3.908,0,0,0,2.98-1.141l2.874-2.87.04-.04L21.716,7.429a3.021,3.021,0,0,0,0-4.28ZM20.155,5.863l-.783.783L15.959,3.232l.783-.783a.822.822,0,0,1,1.159,0L20.155,4.7A.822.822,0,0,1,20.155,5.863Z" transform="translate(0)" fill="" />
                                </g>
                            </svg>
                        </NavLink>


                        <button
                            onClick={() => setShareModalOpen(!shareModalOpen)}
                            className="flex justify-center items-center
                            relative filter drop-shadow-md global_icons_only_hover
                            w-[35px] h-[35px]
                            xsm:w-[42px] xsm:h-[42px]">
                            <svg className="w-full h-full absolute inset-0 z-[-1] 
                                    fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-3 sm:w-4 fill-cusBlack dark:fill-white" width="24.476" height="24.475" viewBox="0 0 24.476 24.475">
                                <path id="Union_10" data-name="Union 10" d="M10136.334,14296.156a4.8,4.8,0,0,1,.262-1.57l-6.182-3.3a4.822,4.822,0,1,1,.015-5.075l6.177-3.294a4.828,4.828,0,1,1,.706,1.313l-6.306,3.363a4.849,4.849,0,0,1-.007,2.314l6.3,3.358a4.82,4.82,0,1,1-.961,2.888Z" transform="translate(-10121.501 -14276.502)" fill="" />
                            </svg>
                        </button>
                    </div>
                </div>


                <ScrollContainer
                    nativeMobileScroll={true}
                    horizontal={true}
                    className="scroll-container flex justify-start items-end mt-8 relative overflow-auto">
                    <NavLink to="/profile/overview" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Overview
                    </NavLink>
                    <NavLink to="/profile/activity" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Activity
                    </NavLink>
                    <NavLink to="/profile/posts" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Posts
                    </NavLink>
                    <NavLink to="/profile/onSale" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        On sale
                    </NavLink>
                    <NavLink to="/profile/owned" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Owned
                    </NavLink>
                    <NavLink to="/profile/created" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Created
                    </NavLink>
                    <NavLink to="/myCollections" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Collections
                    </NavLink>
                    <div className="w-full border-2 border-[#DEDEDE] dark:border-[#201753] flex-1 align-bottom"></div>
                </ScrollContainer>


                <Outlet />
            </div>





            {/* Request for Verification modal */}
            <AnimatePresence>
                {verifiedArtist &&
                    <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={verifiedArtist ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={verifiedArtistRef} className="relative inline-block align-bottom
                                listening_modal_gredi_box rounded-xl text-left overflow-hidden shadow-2xl
                                transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
                                <div className="listening_modal rounded-xl bg-white dark:bg-[#292757] py-4 px-3 sm:py-5 sm:px-7">

                                    <div className="flex justify-between items-center">
                                        <h4 className="text-base sm:text-lg md:text-xl text-cusBlack dark:text-white font-bold w-10/12">Why become an UNC verified artist?</h4>
                                        <button onClick={() => setVerifiedArtist(false)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 md:w-auto dark:stroke-white stroke-cusBlack" width="21.855" height="21.856" viewBox="0 0 21.855 21.856">
                                                <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="" strokeLinecap="round" strokeWidth={3} />
                                                <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="" strokeLinecap="round" strokeWidth={3} />
                                            </svg>
                                        </button>
                                    </div>


                                    <div className="mt-6">

                                        <div className="flex justify-start items-start">
                                            <div className="">
                                                <img src={greenTik} alt="" className="w-5 sm:w-8" />
                                            </div>
                                            <p className="text-xxs sm:text-sm xl:text-base text-cusBlack dark:text-white ml-2">UNC verified users will be able to sell nets via visa/Mastercard</p>
                                        </div>

                                        <div className="flex justify-start items-start mt-6 ">
                                            <div className="">
                                                <img src={greenTik} alt="" className="w-5 sm:w-8" />
                                            </div>
                                            <p className="text-xxs sm:text-sm xl:text-base text-cusBlack dark:text-white ml-2">Verified artists can stake their nft’s in UNC Staking Program</p>
                                        </div>
                                        <div className="flex justify-start items-start mt-6 ">
                                            <div className="">
                                                <img src={greenTik} alt="" className="w-5 sm:w-8" />
                                            </div>
                                            <p className="text-xxs sm:text-sm xl:text-base text-cusBlack dark:text-white ml-2 -mt-0.5">Be an exclusive part of the first-ever hybrid Social NFT Marketplace</p>
                                        </div>
                                    </div>



                                    <NavLink to="/requestForVerification"
                                        className="text-white xs:mt-7 md:mt-10 w-full xs:py-2.5 md:py-4 rounded-lg gradientBtn inline-block text-center
                                    text-xs sm:text-base">
                                        Verify Now
                                    </NavLink>

                                </div>
                            </motion.div>
                        </div>
                    </div>}
            </AnimatePresence>




            {/* Profile Share Modal */}
            <AnimatePresence>
                {shareModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={shareModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={shareModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left overflow-hidden transform transition-all sm:align-middle
                                                 w-11/12 xsm:max-w-sm md:max-w-sm xl:max-w-md xsm:w-full">

                                <div className="flex justify-between items-center px-6 pt-5">
                                    <h5 className="text-cusBlack dark:text-white text-xl font-extrabold dark:font-bold">Share</h5>

                                    <button onClick={() => setShareModalOpen(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>
                                <div className="border-b border-[#dedede] dark:border-[#473a94] mt-2"></div>

                                <div className="px-6 py-3 flex justify-start items-center">
                                    <p className="text-cusBlack dark:text-white font-bold">To:</p>
                                    <input type="text" name="" id=""
                                        onChange={handleShareModalSearch}
                                        placeholder="Search..."
                                        className="bg-transparent outline-none w-full ml-2 text-cusBlack dark:text-white"
                                    />
                                </div>

                                <div className="border-b border-[#dedede] dark:border-[#473a94] "></div>

                                <div className="pl-6 pt-3">
                                    <p className="text-cusBlack dark:text-white font-bold text-sm">Suggested</p>

                                    <div className="flex flex-col pb-2 h-[200px] sm:h-[300px] xl:h-[320px] overflow-auto mt-2">
                                        {modalPeoplesData.map((people, index) =>
                                            <label htmlFor={`shareToPeople${index}`} key={people.id}>
                                                <div className="flex justify-between items-center 
                                                hover:bg-[#00000010] dark:hover:bg-[#00000020] pl-3 py-[7px] pr-7 rounded-l-lg">
                                                    <div className="flex justify-start items-center">
                                                        <div className="
                                                        w-[40px] h-[40px]
                                                        md:w-[50px] md:h-[50px] rounded-full overflow-hidden">
                                                            <div>
                                                                <img src={people.photo} alt="" className="w-full h-full" />
                                                            </div>
                                                        </div>
                                                        <div className="text-left ml-3">
                                                            <h5 className="text-cusBlack dark:text-white text-sm lg:text-base
                                                            max-w-[100px] xxsm:max-w-[120px] sm:max-w-[160px] truncate">{people.name}</h5>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <input type="checkbox"
                                                            name="shareToPeopleCheckbox" id={`shareToPeople${index}`}
                                                            className="bg-transparent cursor-pointer border-2 dark:border-[#ff0091]
                                                            dark:checked:bg-[#ff0091] checked:bg-[#2563eb] dark:focus:outline-pink-600
                                                            w-4 h-4 md:w-5 md:h-5 focus:outline-none rounded-full form-checkbox transition-all" />
                                                    </div>
                                                </div>

                                            </label>
                                        )}
                                    </div>
                                </div>


                                <div className="px-6 py-3 xl:py-4">
                                    <button className="w-full py-2 gradientBG text-white font-bold rounded-md
                                     hover:tracking-wider transition-all duration-300">
                                        Send
                                    </button>

                                    <button className="w-full py-2 flex justify-center items-center mt-3 border-2 border-[#c5c5c5] dark:border-[#8481c5]
                                rounded-lg group
                                    ">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 md:w-6 stroke-l-LightBlack dark:stroke-cusBlueWhite" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                                        </svg>

                                        <p className="text-l-LightBlack dark:text-cusBlueWhite ml-1 font-semibold 
                                        group-hover:tracking-wider transition-all duration-300 select-none text-sm md:text-base
                                        ">Copy Link</p>
                                    </button>
                                </div>

                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>













        </div>
    );
}

